import React, {useState, useEffect,} from 'react';
import './App.css';
import { BrowserRouter as Router, Link, Route} from 'react-router-dom';
import axios from 'axios';
import PrayerRequestForm from './components/PrayerRequestForm';
import PrayerRequestIndex from './components/PrayerRequestIndex';
import TeachingsForm from './components/TeachingsForm';
import Teachings from './components/Teachings';
import TeachingShow from './components/TeachingShow'
import Home from './components/Home';
import crossLogo2 from './components/imgs/crossLogo2.png';
import Login from './components/Login';
import Register from './components/Register'
import About from './components/About';
import dave from './components/imgs/daveHeadshot.png'

// const endpoint ="http://localhost:3000"
const api = "https://cyrene-api.herokuapp.com"

export default function App(props) {
  const [state, setState] = useState({
    prayer_request:{
    name: '',
    state:'',
    temptation:'',
    }
  })
  const [view, setView] = useState({
    viewForm: false
  })

  const viewFormButton =(event)=>{
    setView({viewForm: true})
  }
  const closeForm= (event) => {
    setView({viewForm: false})
  }
  const handleChange = (event) =>{
    const updateInput = Object.assign({}, formInputs, { [event.target.id]: event.target.value}, )
    updateFormInputs(updateInput)
  }
  const [requests, setRequests] = useState([])
  const [formInputs, updateFormInputs] = useState({
    name: '',
    state: state,
    temptation: state,
  })

  const teachingFormChange = (event) => {
    const updateTeaching = Object.assign({}, teachingInputs, { [event.target.id]: event.target.value})
    updateTeachingInputs(updateTeaching)
    }
  const [teachings, setTeachings] = useState([])
  const [teachingInputs, updateTeachingInputs] = useState({
    title: '',
    bibleVerse: '',
    reading: '',
    cccParagraph: '',
    content: '',
    prayer: '',
    temptation: ''
    })
    const [admin, setAdmin] = useState({
      user:{
      id: '',
      username: '',
      password: '',
      isLoggedIn: false
      }
    })
    const handleUserForm = (event) =>{
      // const updateUserForm = Object.assign({}, {user:{...state.user,  [event.target.id]: event.target.value}})
      // setState(updateUserForm)
      setAdmin({...admin, [event.target.id]: event.target.value})
      }

    const [isLoggedIn, setIsLoggedIn] = useState(false)

//=======================
//    Use Effect
//=======================
useEffect(() => {
  if (localStorage.user /*|| localStorage.user.token*/){
    setIsLoggedIn(true);
  }else {
        setIsLoggedIn(false)};
        
  }, [isLoggedIn]);

  console.log(isLoggedIn)

//==================================
//            Admin Log In
//==================================
const login = async (event) => {
  event.preventDefault();
  return axios
  .post( `${api}/users/login`, {
    user:{
      username: admin.username,
      password: admin.password,
      }
  })
  
  .then(response => {
    if (response.data.token){
      localStorage.setItem('user', JSON.stringify(response.data))
    setIsLoggedIn(true)
    }; (console.log(response.data))
    return response.data
  });
}
const logout=()=>{
 localStorage.removeItem('user', 'token');
 setIsLoggedIn(false)
}

//==================================
//        Register New Admin
//==================================
const register = async(event) => {
  event.preventDefault();
  return axios
  .post( `${api}/users/`, {
    user:{
      username: admin.username,
      password: admin.password,
      }
  })
  
  .then(response => {
    if (response.data.token){
      localStorage.setItem('user', JSON.stringify(response.data))
    setIsLoggedIn(true)
    }; (console.log(response.data))
    return response.data
  });
}
  
//==================================
//        Submit New Request
//==================================

const handleSubmit = async (event) =>{
  event.preventDefault()
  try {
    const response = await fetch(`${api}/prayerrequests`, {
      body: JSON.stringify(formInputs),
      method:'POST',
      // mode: 'cors',
      headers: {
        'Accept': 'application/json, text/plain, text/password, */*',
        'Content-Type': 'application/json'
      }
    })
    const data = await response.json()
    updateFormInputs({
      name: '',
      state: '',
      temptation: ''
    })

    
    setRequests([data, ...requests])
    console.log(formInputs)
  }catch(error) {
    console.log(error)
  }setState({viewForm:false})
}

//==============================
// Submit new Catechism Teaching
//==============================
const submitTeaching = async (event) =>{
  event.preventDefault()
  try{
    const response = await fetch(`${api}/teachings`, {
      body: JSON.stringify(teachingInputs),
      method: 'POST',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      }
      
    })
    const data = await response.json()
    updateTeachingInputs({
    title: '',
    bibleVerse: '',
    reading: '',
    cccParagraph: '',
    content: '',
    prayer: '',
    temptation: ''
    })
    setTeachings([data, ...teachings])
      console.log(teachingInputs)
  }catch(error){
    console.log(error)
  }
}

//==================================================

  return (
    <Router>
    <div className="App">
      
      <img src={crossLogo2} id="logo" alt="cyrene-cross" />
      <header className="App-header">
        <nav id="hamnav">
          <label htmlFor="hamburger">&#9776;</label>
          <input type="checkbox" id="hamburger"/>
        <div id="hamitems">
          <ul>
            <Link to='/'>
            <li>Home</li>
            </Link>
            <Link to='/teachings'>
            <li>Catechism</li>
            </Link>
            <Link to='/prayerrequests'>
            <li>Prayer Requests</li>
            </Link>
            <Link to='/resources'>
            <li>Resources</li>
            </Link>
            <Link to='/about'>
            <li>About</li>
            </Link>
            {isLoggedIn? 
            <li onClick={logout}>Log Out</li> : ''
            }
         </ul> 
        </div>
        {(view.viewForm)? '' : <div id="prayer-req-form" onClick={viewFormButton}>How May We Pray for You?</div>
          }
          {(view.viewForm)?
          <div><PrayerRequestForm 
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          formInputs={formInputs}
           /><button id="close" onClick={closeForm}>Close</button></div>  
          :''} 
        
      </nav>
       
      </header>
      <div className="body">
        <Route exact path='/teachings' 
          component={Teachings}
          // requestTeachings={teachings}
          // getTeachings={getTeachings}
           />
          <Route exact path='/teachings/:id' 
          render={(props) =>{
          return(
            <TeachingShow
            {...props}
            teachings={teachings} />
          )}} />
        <Route path='/prayerrequests'
          component={PrayerRequestIndex} />
        <Route path='/login'
          render={(props) => {
            return (
              <Login
              setIsLoggedIn={setIsLoggedIn}
              isLoggedIn={isLoggedIn}
              login={login}
              handleUserForm={handleUserForm}
              logout={logout}/>
            )}
          } />
          <Route path='/register'
          render={(props) =>{
            return(
              <Register
              setIsLoggedIn={setIsLoggedIn}
              isLoggedIn={isLoggedIn}
              register={register}
              handleUserForm={handleUserForm} />
            )
          }}/>
          <Route path='/teachings/new'
          render ={(props) =>{
            return(
              <TeachingsForm
              isLoggedIn={isLoggedIn}
              submitTeaching={submitTeaching}
              teachingInputs={teachingInputs}
              teachingFormChange={teachingFormChange} />
            )
          }} />
          <Route path='/about'
          component={About} 
          dave={dave}
          />
        <Route path='/' exact 
          component={Home}/>
        
      </div>
    
    <div className="footer">
      <ul>  
        <Link to='/login'>
        <li>Admin Log In</li>
        </Link>
      {isLoggedIn ? 
      <Link to ='/teachings/new'>
       <li>Submit Catechism</li>
      </Link> 
      : ''}
      {isLoggedIn ?
      <Link to='/register'>
        <li>Register</li>
      </Link> : ''}
      </ul>
    </div>
    </div>
    </Router>
  );
}

